import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Section, Container } from '../../ui';
import { SearchX, ShieldAlert, Settings, FileCheck, ChevronDown } from 'lucide-react';
import {
  IllustrationSourcingOpaque,
  IllustrationDefiImage,
  IllustrationComplexiteMetier,
  IllustrationConformiteFloue,
} from '../../icons';
import styles from './Challenges.module.css';

const icons = [SearchX, ShieldAlert, Settings, FileCheck];
const illustrations = [
  IllustrationSourcingOpaque,
  IllustrationDefiImage,
  IllustrationComplexiteMetier,
  IllustrationConformiteFloue,
];

export function Challenges() {
  const { t } = useTranslation('home');
  const [activeIndex, setActiveIndex] = useState(0);

  const challenges = t('challenges.items', { returnObjects: true }) as { title: string; text: string }[];

  return (
    <Section variant="blue">
      <Container>
        <div className={styles.wrapper}>
          <h2 className={styles.heading}>{t('challenges.heading')}</h2>
          <div className={styles.splitGrid}>
            <div className={styles.accordionCol}>
              {challenges.map((challenge, i) => {
                const Icon = icons[i];
                const Illustration = illustrations[i];
                const isActive = activeIndex === i;
                return (
                  <div
                    key={i}
                    className={`${styles.accordionItem} ${isActive ? styles.active : ''}`}
                  >
                    <button
                      className={styles.accordionHeader}
                      onClick={() => setActiveIndex(i)}
                      aria-expanded={isActive}
                    >
                      <div className={styles.iconWrapper}>
                        <Icon size={20} strokeWidth={1.5} />
                      </div>
                      <span className={styles.accordionTitle}>{challenge.title}</span>
                      <ChevronDown size={18} className={styles.chevron} />
                    </button>
                    <div className={styles.accordionContent}>
                      <div className={styles.accordionInner}>
                        <p className={styles.accordionText}>{challenge.text}</p>
                        <div className={styles.mobileIllustration}>
                          <Illustration className={styles.illustrationSvg} />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className={styles.illustrationCol}>
              {illustrations.map((Illustration, i) => (
                <div
                  key={i}
                  className={`${styles.illustrationPane} ${activeIndex === i ? styles.illustrationActive : ''}`}
                >
                  <Illustration className={styles.illustrationSvg} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
